import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ArticleView } from "@/components/news/ArticleView";

const isUpcoming = (ev) => {
  if (!ev?.start) return false;
  const end = new Date(ev.end || ev.start);
  return end.getTime() >= Date.now(); // approximate in-browser preview (local time)
};

export const toView = (form, cats, publishAt) => ({
  ...form,
  category: { name: cats.find((c) => c.slug === form.category)?.name ?? "" },
  event: form.hasEvent ? form.event : null,
  is_upcoming: form.hasEvent && isUpcoming(form.event),
  publish_at: publishAt,
});

export const PreviewDialog = ({ open, onClose, view }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="h-[92vh] max-w-6xl overflow-y-auto bg-paper p-0" data-lenis-prevent data-testid="news-preview-dialog">
      <DialogTitle className="sticky top-0 z-10 bg-gold px-4 py-2 text-center text-xs font-bold uppercase tracking-[0.2em] text-navy">
        Preview: this is how the article will look. Nothing is published yet.
      </DialogTitle>
      <div className="[&_header]:pt-12 md:[&_header]:pt-14">{view && <ArticleView a={view} />}</div>
    </DialogContent>
  </Dialog>
);
